// seedScorePages/SharedForms/ProgressBar.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ProgressBar.css';

// Step tanımları (JSON anahtarlarıyla)
const steps = [
  { id: 1, key: 'steps.entrepreneurInfo', route: '/entrepreneur-info' },
  { id: 2, key: 'steps.financialTable', route: '/financial-table' },
  { id: 3, key: 'steps.assessment', route: '/assessment' },
  { id: 4, key: 'steps.dashboard', route: '/dashboard' }
];

const ProgressBar = ({ currentStep: propCurrentStep }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const getCurrentStepFromRoute = () => {
    const currentRoute = location.pathname;

    if (currentRoute.includes('/entrepreneur-info')) return 1;
    if (currentRoute.includes('/financial-table')) return 2;
    if (currentRoute.includes('/assessment')) return 3;
    if (currentRoute.includes('/dashboard') || currentRoute.includes('/report')) return 4;

    return 1; // varsayılan ilk adım
  };

  const currentStep = propCurrentStep || getCurrentStepFromRoute();

  return (
    <div className="progress-container">
      {steps.map((step, index) => {
        const isActive = currentStep === step.id;
        const isCompleted = currentStep > step.id;
        const isConnectorActive = currentStep > step.id;

        return (
          <React.Fragment key={step.id}>
            <div className={`step-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
              <div className={`step-circle ${isCompleted ? 'completed' : isActive ? 'active' : ''}`}>
                {isCompleted ? '✓' : step.id}
              </div>
              <div className="step-label">{t(step.key)}</div>

              {/* Adımlar arası çizgi */}
              {index < steps.length - 1 && (
                <div className={`step-connector ${isConnectorActive ? 'active' : ''}`}></div>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressBar;
